import { LegalPage } from "@/components/site/LegalPage";
import { Seo, breadcrumb } from "@/components/site/Seo";

export default function Terms() {
  return (
    <>
    <Seo title="Terms of Service — OpenDegree" description="The terms governing use of the OpenDegree platform for learners and education providers." path="/terms" jsonLd={breadcrumb([{ name: "Home", path: "/" }, { name: "Terms", path: "/terms" }])} />
    <LegalPage
      testid="terms-page"
      title="Terms of Service"
      updated="June 2026"
      intro="These placeholder terms describe the intended use of the OpenDegree platform. Final terms will be published before public launch."
      sections={[
        { h: "Pre-Launch Status", p: "OpenDegree is currently under development. The platform is not yet available for live applications, and information on this website is provided for introductory purposes only." },
        { h: "Use of the Platform", p: "Once live, students agree to provide accurate information and to use the platform solely for genuine higher education admissions purposes." },
        { h: "Provider Partnerships", p: "Higher education providers partnering with OpenDegree agree to handle student data responsibly and to respond to applications in a timely manner." },
        { h: "Automation & Human Support", p: "While OpenDegree automates admissions tasks wherever possible, human support remains available. Automated recommendations do not guarantee admission." },
        { h: "Contact", p: "For questions about these terms, please email hello@opendegree.co.uk. These terms will be finalised prior to public launch." },
      ]}
    />
    </>
  );
}
